import { useGetMerchantQuery } from "Api/Queries/Merchants/useGetMerchantQuery";
import { MerchantCompleteRegistrationPageInitializer } from "Components/Hunter/Merchants/CompleteRegistration/MerchantCompleteRegistrationPageInitializer";
import { MerchantCompleteRegistrationPageSkeleton } from "Components/Hunter/Merchants/CompleteRegistration/MerchantCompleteRegistrationPageSkeleton";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { getAppUrl } from "Utils/UrlUtils";
import type { ReactNode } from "react";
import { useParams } from "react-router";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES = Resources.Hunter.Merchants.CompleteRegistration;

export const MerchantCompleteRegistrationPage = () => {
  const { t } = useResource();
  const { publicID } = useParams();
  const { data, isLoading, isError } = useGetMerchantQuery(
    publicID,
    !!publicID,
  );

  if (isLoading) {
    return (
      <Layout title={t(COMPONENT_RESOURCES.Title, { company: "" })}>
        <MerchantCompleteRegistrationPageSkeleton />
      </Layout>
    );
  }

  if (isError || !publicID || !data?.party) {
    return (
      <Layout title={t(COMPONENT_RESOURCES.GeneralTitle)}>
        <ErrorText>{t(COMPONENT_RESOURCES.MerchantError)}</ErrorText>
      </Layout>
    );
  }

  return (
    <Layout
      title={
        data.party.companyName
          ? t(COMPONENT_RESOURCES.Title, {
              company: data.party.companyName,
            })
          : t(COMPONENT_RESOURCES.GeneralTitle)
      }
    >
      <MerchantCompleteRegistrationPageInitializer merchantDetail={data} />
    </Layout>
  );
};

export default MerchantCompleteRegistrationPage;

type LayoutProps = { children: ReactNode; title: string };

const Layout = ({ children, title }: LayoutProps) => {
  const appUrl = getAppUrl();

  return (
    <AuthenticatedLayout
      title={title}
      backNavigation={{
        mode: "staticUrl",
        url: appUrl("merchant-open-registrations"),
      }}
    >
      {/* override maxWidth, because we want the content wider than the default 600px limit of StyledPageWrapper */}
      <StyledPageWrapper
        maxWidth="unset !important"
        minWidth={["350px", "600px", "unset"]}
      >
        <div className="left-content">{children}</div>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};
